import React, { ChangeEventHandler } from 'react'
import {
  BaseTextFieldProps,
  Box,
  BoxProps,
  TextField,
  Typography
} from '@mui/material'

interface Props extends BoxProps {
  label: string
  error?: boolean
  value?: string
  onChange?: ChangeEventHandler<HTMLInputElement>
  helperText?: string
  name?: string
  type?: BaseTextFieldProps['type']
}

const Input = React.forwardRef(
  (
    {
      label,
      error,
      value,
      onChange,
      type,
      helperText,
      name,
      ...restProps
    }: Props,
    ref
  ) => {
    // const { name, type, label, placeholder, ...restProps } = props;

    return (
      <Box {...restProps}>
        <Typography
          sx={{
            color: ({ palette }) =>
              error ? palette.error.main : palette.text.primaryLight
          }}
        >
          {label}
        </Typography>
        <TextField
          name={name}
          type={type}
          inputRef={ref}
          error={!!error}
          fullWidth
          helperText={helperText}
          sx={{ marginTop: '.25rem' }}
          onChange={onChange}
        />
      </Box>
    )
  }
)

export default Input
